import styled from 'styled-components';

const CourseTitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 8px;

  div {
    padding-left: 12px;
    color: #000000;
    font-family: Lato;
    font-size: 14px;
    font-weight: 900;
    line-height: 20px;
    color: var(--text-text02);

    p {
      margin-left: 0px;
      margin-top: 8px;
      font-family: Lato;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      color: var(--neutrals-neutral02);
    }

    span {
      font-weight: 400;
    }
  }
`;

const ChildrenContainer = styled.div`
  padding: 20px 24px 24px 28px;
`;

const BlockContainer = styled.div`
  .firstBlock {
    @media (min-width: 768px) {
      div {
        column-count: 2;
      }
    }
  }

  .row {
    display: flex;
    @media (max-width: 768px) {
      display: block;
    }
  }

  .column {
    flex: 50%;
  }

  .secondBlock {
    @media (min-width: 640px) {
      display: flex;
      justify-content: space-between;
      margin-bottom: -12px;
    }
  }

  .convalidatedBlock {
    @media (min-width: 640px) {
      columns: 50px 4;
    }
  }

  p {
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
    color: var(--text-text02);
    margin-bottom: 10px;
  }

  ul {
    list-style-type: disc;
    margin-left: 30px;
  }

  span {
    padding-left: 4px;
  }
`;

const EvaluationsBlockContainer = styled.div`
  color: var(--text-text02);
  margin-bottom: 16px;

  p {
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    text-align: left;
    margin-bottom: 8px;
  }

  ul {
    list-style-type: disc;
    margin-left: 30px;
    text-indent: -4px;

    span {
      float: right;
      font-family: Lato;
      font-size: 14px;
      font-weight: 700;
    }
  }

  .relatedCourse {
    color: var(--text-text-disabled);
    p {
      width: 200px;
    }
  }
`;

const FormulaContainer = styled.div`
  padding: 16px;
  background: var(--background-background-UTP);
  color: var(--text-text02);
  border-radius: 10px;
  margin-bottom: 16px;
  span {
    font-size: 14px;
    font-weight: 700;
    margin-right: 4px;
  }

  div {
    display: block;
    @media (min-width: 768px) {
      display: flex;
    }
  }
`;

const FinalGradeContainer = styled.div`
  padding: 12px 16px;
  border-radius: 10px;
  color: var(--text-text02);

  img {
    margin-right: 12px;
    margin-bottom: 3px;
  }

  b {
    padding-left: 8px;
  }

  span {
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    float: right;
    margin-top: -21px;
  }
`;

const DivisionLine = styled.div.attrs((props: any) => ({
  backgroundColor: props.backgroundColor,
  margin: props.margin,
  applyMediaQuery: props.applyMediaQuery
}))`
  border-top: 1px solid ${(props) => props.backgroundColor}; // #d5e5f0 var(--background-background-disabled)    #8090BB var(--text-text-disabled)
  margin: ${(props) => props.margin};

  ${(props) =>
    props.applyMediaQuery &&
    `
    @media (max-width: 639px) {
      margin-left: -16px;
      margin-right: -16px;
    }
  `}
`;

export {
  CourseTitleContainer,
  ChildrenContainer,
  BlockContainer,
  EvaluationsBlockContainer,
  FormulaContainer,
  FinalGradeContainer,
  DivisionLine
};
